import React, { useState } from 'react';
import { Header } from '../../components/layout/Header';
import { Footer } from '../../components/layout/Footer';
import { Button } from '../../components/ui/Button';
import { Card, CardContent, CardFooter } from '../../components/ui/Card';
import { Badge } from '../../components/ui/Badge';
import { Input } from '../../components/ui/Input';
import { FilterChip } from '../../components/ui/FilterChip';
import { Search, Download, Share2, FileImage, Video, FileText, Package, BookOpen } from 'lucide-react';
// Mock Data
const CONTENT_ITEMS = [{
  id: 1,
  title: 'Poster Pilah Sampah Organik',
  type: 'Poster',
  program: 'Pilah Sampah',
  target: 'Masyarakat',
  date: '12 Jan 2025',
  downloads: 1240,
  thumbnailColor: 'bg-green-100',
  icon: FileImage
}, {
  id: 2,
  title: 'Video Tutorial Kompos Rumahan',
  type: 'Video',
  program: 'Kompos',
  target: 'Masyarakat',
  date: '15 Jan 2025',
  downloads: 856,
  thumbnailColor: 'bg-blue-100',
  icon: Video
}, {
  id: 3,
  title: 'Infografis 3R untuk Sekolah',
  type: 'Infografis',
  program: 'Edukasi',
  target: 'Pelajar',
  date: '20 Jan 2025',
  downloads: 2100,
  thumbnailColor: 'bg-yellow-100',
  icon: FileText
}, {
  id: 4,
  title: 'Toolkit Penyuluh Desa',
  type: 'Toolkit',
  program: 'Edukasi',
  target: 'Pemda',
  date: '22 Jan 2025',
  downloads: 540,
  thumbnailColor: 'bg-purple-100',
  icon: Package
}, {
  id: 5,
  title: 'Konten TikTok Ramadhan Minim Sampah',
  type: 'Video',
  program: 'Ramadhan',
  target: 'Masyarakat',
  date: '01 Feb 2025',
  downloads: 3200,
  thumbnailColor: 'bg-pink-100',
  icon: Video
}, {
  id: 6,
  title: 'Panduan Bank Sampah Unit',
  type: 'Buku Saku',
  program: 'Sirkular',
  target: 'Komunitas',
  date: '05 Feb 2025',
  downloads: 980,
  thumbnailColor: 'bg-orange-100',
  icon: BookOpen
}];
export function BankKontenPage() {
  const [activeFilters, setActiveFilters] = useState<string[]>(['Semua']);
  const [searchQuery, setSearchQuery] = useState('');
  const toggleFilter = (filter: string) => {
    if (filter === 'Semua') {
      setActiveFilters(['Semua']);
    } else {
      const newFilters = activeFilters.includes('Semua') ? [filter] : activeFilters.includes(filter) ? activeFilters.filter(f => f !== filter) : [...activeFilters, filter];
      if (newFilters.length === 0) setActiveFilters(['Semua']);else setActiveFilters(newFilters);
    }
  };
  return <div className="min-h-screen bg-background flex flex-col font-sans text-foreground" data-id="element-3872">
      <Header data-id="element-3873" />

      <main className="flex-1 bg-gray-50" data-id="element-3874">
        {/* Header Section */}
        <div className="bg-white border-b border-gray-200 py-8" data-id="element-3875">
          <div className="container mx-auto px-4 md:px-6" data-id="element-3876">
            <h1 className="text-3xl font-bold text-gray-900 mb-4" data-id="element-3877">
              Bank Konten KIE Nasional
            </h1>
            <p className="text-gray-600 max-w-3xl mb-8" data-id="element-3878">
              Pusat unduhan materi edukasi resmi. Gunakan filter untuk menemukan
              poster, video, dan toolkit yang sesuai dengan kebutuhan program
              Anda.
            </p>

            {/* Search Bar */}
            <div className="relative max-w-2xl mb-8" data-id="element-3879">
              <Search className="absolute left-3 top-3 h-5 w-5 text-gray-400" data-id="element-3880" />
              <Input placeholder="Cari materi (misal: poster pilah sampah...)" className="pl-10 h-12 text-lg" value={searchQuery} onChange={e => setSearchQuery(e.target.value)} data-id="element-3881" />
            </div>

            {/* Filters */}
            <div className="space-y-4" data-id="element-3882">
              <div className="flex flex-wrap gap-2 items-center" data-id="element-3883">
                <span className="text-sm font-medium text-gray-500 mr-2" data-id="element-3884">
                  Program:
                </span>
                {['Semua', 'Pilah Sampah', 'Cegah Sampah', 'Kompos', 'Sirkular', 'Teknologi'].map(filter => <FilterChip key={filter} label={filter} active={activeFilters.includes(filter)} onClick={() => toggleFilter(filter)} data-id="element-3885" />)}
              </div>
              <div className="flex flex-wrap gap-2 items-center" data-id="element-3886">
                <span className="text-sm font-medium text-gray-500 mr-2" data-id="element-3887">
                  Format:
                </span>
                {['Poster', 'Video', 'Infografis', 'Toolkit', 'Audio'].map(filter => <FilterChip key={filter} label={filter} active={activeFilters.includes(filter)} onClick={() => toggleFilter(filter)} data-id="element-3888" />)}
              </div>
            </div>
          </div>
        </div>

        {/* Content Grid */}
        <div className="container mx-auto px-4 md:px-6 py-12" data-id="element-3889">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-3890">
            {CONTENT_ITEMS.map(item => <Card key={item.id} className="group hover:shadow-lg transition-all duration-200 border-gray-200" data-id="element-3891">
                <div className={`h-48 ${item.thumbnailColor} flex items-center justify-center relative overflow-hidden`} data-id="element-3892">
                  <item.icon className="h-16 w-16 text-gray-600 opacity-20 group-hover:scale-110 transition-transform duration-300" data-id="element-3893" />
                  <div className="absolute top-3 right-3" data-id="element-3894">
                    <Badge variant="secondary" className="bg-white/90 backdrop-blur-sm shadow-sm" data-id="element-3895">
                      {item.type}
                    </Badge>
                  </div>
                </div>
                <CardContent className="p-5" data-id="element-3896">
                  <div className="flex gap-2 mb-3" data-id="element-3897">
                    <Badge variant="outline" className="text-xs font-normal text-gray-500 border-gray-200" data-id="element-3898">
                      {item.program}
                    </Badge>
                    <Badge variant="outline" className="text-xs font-normal text-gray-500 border-gray-200" data-id="element-3899">
                      {item.target}
                    </Badge>
                  </div>
                  <h3 className="text-lg font-bold text-gray-900 mb-2 line-clamp-2 group-hover:text-primary-600 transition-colors" data-id="element-3900">
                    {item.title}
                  </h3>
                  <p className="text-sm text-gray-500 mb-4" data-id="element-3901">
                    Diunggah {item.date} • {item.downloads.toLocaleString()}{' '}
                    unduhan
                  </p>
                </CardContent>
                <CardFooter className="p-5 pt-0 flex gap-3" data-id="element-3902">
                  <Button className="flex-1 bg-primary-600 hover:bg-primary-700" data-id="element-3903">
                    <Download className="mr-2 h-4 w-4" data-id="element-3904" /> Unduh
                  </Button>
                  <Button variant="outline" size="icon" className="text-gray-500 hover:text-primary-600" data-id="element-3905">
                    <Share2 className="h-4 w-4" data-id="element-3906" />
                  </Button>
                </CardFooter>
              </Card>)}
          </div>

          {/* Pagination / Load More */}
          <div className="mt-12 text-center" data-id="element-3907">
            <Button variant="outline" size="lg" className="min-w-[200px]" data-id="element-3908">
              Muat Lebih Banyak
            </Button>
          </div>
        </div>
      </main>

      <Footer data-id="element-3909" />
    </div>;
}